var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEntrega(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4669 17.1875H24.8139V11.9092C24.8139 11.2891 24.6057 10.6934 24.2384 10.2539L20.1613 5.37598C19.794 4.93652 19.296 4.6875 18.7777 4.6875H16.9779V2.34375C16.9779 1.0498 16.1004 0 15.0189 0H1.95899C0.877464 0 0 1.0498 0 2.34375V17.9688C0 19.2627 0.877464 20.3125 1.95899 20.3125H2.61199C2.61199 22.9004 4.36691 25 6.52997 25C8.69302 25 10.4479 22.9004 10.4479 20.3125H15.6719C15.6719 22.9004 17.4268 25 19.5899 25C21.7529 25 23.5079 22.9004 23.5079 20.3125H25.4669C25.826 20.3125 26.1199 19.9609 26.1199 19.5312V17.9688C26.1199 17.5391 25.826 17.1875 25.4669 17.1875ZM6.52997 22.6562C5.44844 22.6562 4.57098 21.6064 4.57098 20.3125C4.57098 19.0186 5.44844 17.9688 6.52997 17.9688C7.61149 17.9688 8.48895 19.0186 8.48895 20.3125C8.48895 21.6064 7.61149 22.6562 6.52997 22.6562ZM19.5899 22.6562C18.5084 22.6562 17.6309 21.6064 17.6309 20.3125C17.6309 19.0186 18.5084 17.9688 19.5899 17.9688C20.6714 17.9688 21.5489 19.0186 21.5489 20.3125C21.5489 21.6064 20.6714 22.6562 19.5899 22.6562ZM22.8549 12.5H16.9779V7.03125H18.7777L22.8549 11.9092V12.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntrega);
export default __webpack_public_path__ + "static/media/entrega.5cea527aa3dd684232dd4cfcb43aeebf.svg";
export { ForwardRef as ReactComponent };